var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import ProductViewHero from './ProductViewHero';
import IconFeatureItem from '../../../components/IconFeatureItem';
import ImageContentBlock from '../../../components/ImageContentBlock';
import SmallIconFeatureContentBlock from '../../../components/SmallIconFeatureContentBlock';
import ProductsSliderContentBlock from '../../../components/ProductsSliderContentBlock';
import ProductDimensionsContentBlock from './ProductDimensionsContentBlock';
var TileView = /** @class */ (function (_super) {
    __extends(TileView, _super);
    function TileView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TileView.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "l-container" },
                React.createElement(ProductViewHero, { item: this.props.item, cartItem: this.props.item, images: [
                        "/images/products/hero/" + this.props.item.id + "/1.jpg",
                        "/images/products/hero/" + this.props.item.id + "/2.jpg",
                        "/images/products/hero/" + this.props.item.id + "/3.jpg",
                    ] },
                    React.createElement("div", null,
                        React.createElement(IconFeatureItem, { image: "/images/products/features/sticks-on-wall.svg", title: "product_view.item2.features1.title", content: "product_view.item2.features1.content" }),
                        React.createElement(IconFeatureItem, { image: "/images/products/features/place-and-replace.svg", title: "product_view.item2.features2.title", content: "product_view.item2.features2.content" }),
                        React.createElement(IconFeatureItem, { image: "/images/products/features/create-layout.svg", title: "product_view.item2.features3.title", content: "product_view.item2.features3.content" }))),
                React.createElement(ProductDimensionsContentBlock, { image: "/images/tiles-dimensions.png?v4", dimensions: [
                        'tiles_dimensions.item1',
                        'tiles_dimensions.item2',
                        'tiles_dimensions.item3',
                    ] }),
                React.createElement("div", { className: "h-margin-top--md-40" },
                    React.createElement(ImageContentBlock, { image: "/images/products/tiles/no-tools-needed.jpg?v3", title1: "product_view.item2.section2.title", title2: "product_view.item2.section2.subtitle", content: "product_view.item2.section2.content" }),
                    React.createElement(ImageContentBlock, { image: "/images/products/tiles/bright-colors.jpg?v3", title1: "product_view.item2.section3.title", title2: "product_view.item2.section3.subtitle", content: "product_view.item2.section3.content", order: "content-image" }))),
            React.createElement("div", { className: "h-padding-top--40 h-padding-top--md-60" },
                React.createElement(SmallIconFeatureContentBlock, { items: [
                        {
                            image: '/images/products/features/recycled-box.svg',
                            title: 'product_view.bottom_features.item1.content',
                        },
                        {
                            image: '/images/products/features/natural-glue.svg',
                            title: 'product_view.bottom_features.item2.content',
                        },
                        {
                            image: '/images/products/features/recycled-paper.svg',
                            title: 'product_view.bottom_features.item3.content',
                        },
                    ] })),
            React.createElement(ProductsSliderContentBlock, { items: [1, 4], title: "product_view.other_products.title", subtitle: "product_view.other_products.subtitle" })));
    };
    return TileView;
}(React.Component));
export default TileView;
